export const SUPPORT_EMAIL = 'pdl-lab-numerique@enedis.fr'

const SUPPORT_REQUEST_MAIL_SUBJECT = '[YYX] - Mon Orga: Demande de support'

const BUG_REPORT_MAIL_SUBJECT = '[YYX] - Mon Orga: Signalement de bug'

export function buildSupportRequestMailtoHref(): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(SUPPORT_REQUEST_MAIL_SUBJECT)}`
}

export function buildBugReportMailtoHref(body: string): string {
  const params = new URLSearchParams({
    subject: BUG_REPORT_MAIL_SUBJECT,
    body,
  })
  return `mailto:${SUPPORT_EMAIL}?${params.toString()}`
}
